module.exports = __webpack_public_path__ + "static/media/3.4 KC Tribunj 4-14.08.2025.0b997ec1.JPG";